import { useSelector } from 'react-redux';
import { Icon, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { useShowAddonsShop } from '@app/hooks';
import { selectHasAddons } from '@app/redux';
import { selectLocale } from '@app/redux/locale';

import { Locale } from '@mfe/shared/schema-types';

import { getNavItems } from './utils';
import { ProfileTab } from '../../types';

import styles from './styles.module.scss';

type ExtendedDropdownItemsProps = {
  currentTab: string;
  accountType: string;
  handleTabSwitch: (id: ProfileTab) => void;
};

export const ExtendedDropdownItems = ({ currentTab, accountType, handleTabSwitch }: ExtendedDropdownItemsProps) => {
  const { t } = useTranslation('Profile');

  const {
    locale: { userLocale },
  } = useSelector(selectLocale);
  const isEnUs = userLocale === Locale.EnUs;

  const showAddonsShop = useShowAddonsShop();
  const hasAddons = useSelector(selectHasAddons);

  const { extendedItems } = getNavItems(currentTab, accountType, t, showAddonsShop || hasAddons);

  return (
    <>
      {extendedItems.map((navItem) =>
        !isEnUs && navItem.id === ProfileTab.InternetPlan ? null : (
          <button className={styles['extendedContainer']} onClick={() => handleTabSwitch(navItem.id)} key={navItem.id}>
            <Icon icon={navItem.icon} color="gray_600" />
            <Txt variant="bodyLargeRegular" ml="8px" color="subtle">
              {navItem.label}
            </Txt>
          </button>
        )
      )}
    </>
  );
};
